import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { FileTextIcon, ZapIcon, LayersIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, StarIcon } from 'lucide-react';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/vxo6nVYiddzBnHSHS2dnrj/Mockup_Pilates_Clinic.png';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: LayersIcon,
  label: 'Sistema completo'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function HeroSection() {
  return <section className="relative overflow-hidden border-b border-[var(--line)] bg-[var(--bg)]" data-id="element-113" data-mp="2rsh3istffoqi">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[var(--rose)]/10 blur-[120px]" aria-hidden="true" data-id="element-114" data-mp="3fi1kj660sbx5" />
      <div className="relative mx-auto max-w-5xl px-4 py-16 text-center sm:py-20" data-id="element-115" data-mp="2ff0i13mgl5la">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex flex-col items-center" data-id="element-116" data-mp="2bdx5apzpjpoa">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-[var(--rose)]/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--rose)]" data-id="element-117" data-mp="2ked1dee4fuj4">
            🧘 Tu Plataforma Digital™
          </p>
          <h1 className="font-serif-display text-4xl font-bold leading-[1.05] text-[var(--text)] sm:text-5xl md:text-6xl" data-id="element-118" data-mp="2u453qusgpry5">
            Pilates <span className="text-[var(--rose)]" data-id="element-119" data-mp="3353515binld1">Clinic</span>
          </h1>
          <p className="mt-5 max-w-2xl text-lg font-semibold text-[var(--text)]" data-id="element-120" data-mp="333059tkkadv4">
            Guía Profesional de Adaptaciones, Seguridad y Movimiento
          </p>
          <p className="mt-2 max-w-xl text-[var(--text-soft)]" data-id="element-121" data-mp="18sdcos0sqk7r">
            El sistema número uno para profesoras y profesores de Pilates en
            Argentina
          </p>
          <p className="mt-5 max-w-2xl text-[var(--text)]/80" data-id="element-122" data-mp="3drmi7wmyg73k">
            Adaptaciones profesionales + protección legal + escalamiento de
            ingresos. Sin miedo. Sin juicios. Sin perder dinero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-123" data-mp="3mufb24bscqvi">
          <img src={HERO_IMAGE} alt="Sistema completo Pilates Clinic: caja con los 6 tomos y los 6 bonos de adaptaciones profesionales" className="mx-auto mt-10 w-full max-w-2xl drop-shadow-[0_30px_60px_rgba(0,0,0,0.55)]" data-id="element-124" data-mp="k1mu4ityec7" />
        </motion.div>

        <div className="mt-10 flex flex-wrap justify-center gap-2" data-id="element-125" data-mp="eevmvjpz1ynb">
          {badges.map(b => <span key={b.label} className="inline-flex items-center gap-2 rounded-lg border border-[var(--line)] bg-[var(--surface)] px-3 py-1.5 text-sm text-[var(--text)]/85" data-id="element-126" data-mp="jcncg73598oc">
              <b.icon className="h-4 w-4 text-[var(--rose)]" aria-hidden="true" data-id="element-127" data-mp="1yxo9aswjr36f" />
              {b.label}
            </span>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-128" data-mp="1pvorhydpjv2f">
          <CtaButton href="https://www.tuplataformadigital.store/cart/47602580324436:1" variant="rose" data-id="element-129" data-mp="1pwzu3uvf2wry">
            Quiero Pilates Clinic
          </CtaButton>
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-[var(--text-soft)]" data-id="element-130" data-mp="2dsm2fnzirwok">
          {trust.map(t => <span key={t.label} className="inline-flex items-center gap-1.5" data-id="element-131" data-mp="28spyfoqto590">
              <t.icon className="h-4 w-4 text-[var(--slate)]" aria-hidden="true" data-id="element-132" data-mp="369539awb8037" />
              {t.label}
            </span>)}
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm font-semibold text-[var(--text)]" data-id="element-133" data-mp="31g3qb8fnyam9">
          <span data-id="element-134" data-mp="2q2a2v74blmmh">6 Tomos</span>
          <span className="text-[var(--slate)]/60" data-id="element-135" data-mp="2q2jut08xe3ut">·</span>
          <span data-id="element-136" data-mp="2c290fn8eq74w">6 Bonos</span>
          <span className="text-[var(--slate)]/60" data-id="element-137" data-mp="2c30wt09tw8w8">·</span>
          <span data-id="element-138" data-mp="2h12i7ruq8kav">Sistema de escalamiento</span>
          <span className="text-[var(--slate)]/60" data-id="element-139" data-mp="2h1vf813vvvft">·</span>
          <span className="inline-flex items-center gap-1" data-id="element-140" data-mp="34qwry0jr1sqw">
            4.9/5
            <StarIcon className="h-4 w-4 fill-[var(--rose)] text-[var(--rose)]" aria-hidden="true" data-id="element-141" data-mp="34t0tibu6efo0" />
          </span>
        </div>
      </div>
    </section>;
}